import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApproveTrainingCourseRequestApiModel,
  RejectTrainingCourseRequestApiModel,
  TrainingCourseRequestApiModel
} from '@app/api/api-models';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TrainingCourseRequestsService {
  public apiUrl = 'training-course-requests';

  constructor(private readonly http: HttpClientService) {}

  public get(id: number, trainingCourseClassId: number): Observable<TrainingCourseRequestApiModel> {
    const params = toQueryParams({
      trainingCourseClassId: trainingCourseClassId
    });

    return this.http.get<TrainingCourseRequestApiModel>(`${this.apiUrl}/${id}`, { params: params });
  }

  public add(model: TrainingCourseRequestApiModel): Observable<TrainingCourseRequestApiModel> {
    return this.http.post<TrainingCourseRequestApiModel>(`${this.apiUrl}`, model);
  }

  public approve(model: ApproveTrainingCourseRequestApiModel): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/approve`, model);
  }

  public reject(model: RejectTrainingCourseRequestApiModel): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/reject`, model);
  }
}
